import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import { DialogButton } from "../../components";
import { EmptyOrders } from "../../svgs";

const SalesEmpty = ({ type = "lead" }) => {
  const isLead = type === "lead";
  const dialogName = isLead ? "edit-lead" : "edit-quote";
  const label = isLead ? "Create Lead" : "Create Quote";
  const title = isLead ? "No Leads Yet" : "No Quotes Yet";
  const subtitle = isLead
    ? "Start building your pipeline by adding your first lead."
    : "Add a quote to start tracking parts through the quoting process.";

  return (
    <Stack gap="25px" margin="auto" alignItems="center" padding="40px">
      <Box component="img" src={EmptyOrders} sx={{ height: "120px" }} />
      <Stack gap="10px" alignItems="center" textAlign="center">
        <Typography variant="boldCaption">{title}</Typography>
        <Typography variant="caption" maxWidth="280px">
          {subtitle}
        </Typography>
        <DialogButton
          name={dialogName}
          label={label}
          variant="contained"
          size="small"
        />
      </Stack>
    </Stack>
  );
};

export default SalesEmpty;
